import { QRFC } from "./QRFC";
import { PollForPlanChanges } from "../utils/PollForPlanChanges";

export class QLoadPlanSubmissionsRFC extends QRFC {
  constructor() {
    super();
  }

  InitLoadPlanSubmissions(callbackObj) {
    this.InitRemoteCall(callbackObj, "POST", true, false);
    this.SetAllowStacked(true);
    this.SetAsync(true);
  }

  GetCallName() {
    return "planning/qplanrfc";
  }

  SetParams(orgName, user, mode, data) {
    this.AddParameter("data", data);
    this.AddParameter("mode", mode);
    this.AddParameter("org", orgName);
    this.AddParameter("user", user);
  }

  DoTransactionComplete(response, callBackObj) {
    var wsMgr = callBackObj.fWSMgr ?? callBackObj;
    var planMgr = wsMgr.fPlanManager;
    var r = this.SafeParseResponse(response, err => {
      callBackObj.HandleFailedSvrQuery({ error: err });
    });
    if (!r) {
      return;
    }

    if (r["success"]) {
      if (planMgr) {
        planMgr.SetPlanSubmission(r["activeSubmission"] || null);
        if (r["planSubmissionmd5"]) {
          planMgr.SetPlanSubmissionHash(r["planSubmissionmd5"]);
        }
        planMgr.UpdateContext();
        wsMgr.UpdateDocContext();
        // Broadcast topic to notify components that need submissions list updates
        wsMgr.BroadcastTopic("planSubmissionUpdated", { planMgr: planMgr });
        PollForPlanChanges(false);
      }
    } else {
      // Pass r directly so error codes (e.g. 6000) route to their specific handlers
      callBackObj.HandleFailedSvrQuery(r);
    }
  }
}
